import {QuestionnaireAnswers} from 'api/types/properties'
import {TFunction} from 'react-i18next'

export type QuestionnaireType = 'post' | 'pre'

export const filterAnswers = (answers: QuestionnaireAnswers, t: TFunction) => {
    const filteredAnswers: QuestionnaireAnswers = {...answers}

    Object.keys(filteredAnswers).forEach((key) => {
        // Booleans are checked here even tho quationnaire answers are likely to be strings,
        // at least it seems that false as a pre_answer value is not even saved
        if (filteredAnswers[key] === 'true' || filteredAnswers[key] === true) {
            filteredAnswers[key] = t('yes')
        } else if (answers[key] === 'false' || filteredAnswers[key] === false) {
            filteredAnswers[key] = t('no')
        }
    })

    return filteredAnswers
}
